import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import AppAction from "./AppAction";

export default class AppActions extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id:props.id,
            controllerName: 'appaction',
            data: null,
            loading: true,
            configName: 'appaction_grid',
            moduleName: 'مدیریت عملیات ',
            filters: {
                title: ""
              }
        };
    }
    componentDidMount() { 
        this.refreshData();
    }

    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "title", caption: "عنوان", show: true },
                { field: "order", caption: "ترتیب", show: true },              
                { field: "createDateString", caption: "تاریخ ثبت", show: true },
                { field: "editDateString", caption: "تاریخ بروزرسانی", show: true }
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'title' && f.show) t.push({ field: f.field, flex: 3, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.title}</a> } });
            if (f.field == 'order' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'editDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'createDateString' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        t.push({
            field: 'id', filter: false, headerName: 'عملیات', cellRenderer: (props) => {
                return [
                 
                    <a className="hand text-danger" onClick={e => this.confirmRemove(props.data.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-trash"></em><span>حذف</span></a>
                                                                            
                ]
            }
        });
        return t;
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({
            component: (
            <AppAction Caller={this}  />
            ),
        });
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({
            component: <AppAction Caller={this} Id={id} /> });
    }
    renderForm() {
      if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);
      
        return (
          <div>
            <div className="nk-content-body">
              <div className="nk-block">
                {this.getToolBar(false, {
                  add: true,
                  print: false,
                  pdf: false,
                  excell: false,
                  remove: false,
                  config: false,
                  otherFilters: null,
                })}
                {this.renderAgGrid({
                  columnDefs: this.getColumns(),
                })}
              </div>
            </div>
          </div>
        );
    }
    render() {
         if (!this.isBlank(this.state.redirect))
              return <Navigate to={this.state.redirect} />;
        
            let contents = this.state.loading
              ? this.renderLoading()
              : [
                  this.state.lockScreen === 1 && this.lockScreen(),
                  this.getGlobalContainer(),
                  <Header data={this.state.data} />,
                  <div className="nk-content ">
                    <div className="container-fluid">
                      <div className="nk-content-inner">{this.renderForm()}</div>
                    </div>
                  </div>,
                  <Footer />,
                  this.renderPopupComponent(),
                ];
        
            return contents;
    }
}